export default __webpack_public_path__ + "static/media/media.b68a2ea9.svg";